import { useState, useEffect, useContext } from "react";
import AsyncComponent from "components/common/AsyncComponent";
import { performRequest } from "network/perform-request";
import CreateTournamentWizard from "./CreateTournamentWizard";
import GestionLeagueTournamentWizard from "../Gestion/tournament-wizard/GestionLeagueTournamentWizard";
import { competitionsShowRoute } from "network/api-routes";
import UserContext from "context/UserContext";
import CompetitionDrawer from "../Competition/CompetitionDrawer";
import GestionDrawer from "../Gestion/GestionDrawer";
import GestionSubscriptionGate from "../Gestion/GestionSubscriptionGate";
import Loading from "../../common/Loading";
import { useGestionShellCompetition } from "hooks/useGestionShellCompetition";
import RevaText from "components/common/RevaText";
import { useIntl } from "react-intl";
import { Alert } from "@mui/material";

const AsyncPageWithDrawer = AsyncComponent(() => import("../PageWithDrawer"));

export function GestionCreateTournamentPage(props) {
  const intl = useIntl();
  const { shell, ready, tournamentCreation } = useGestionShellCompetition();

  if (!ready) return <Loading />;
  if (tournamentCreation?.allowed === false) {
    return (
      <Alert data-testid="tournament-creation-blocked" severity="warning" sx={{ m: 3 }}>
        {tournamentCreation.message || intl.formatMessage({ id: "gestion.error.generic" })}
      </Alert>
    );
  }
  if (!shell?.uuid_) {
    return <RevaText>{intl.formatMessage({ id: "gestion.error.generic" })}</RevaText>;
  }

  return <CreateTournamentPage {...props} competitionUUID={shell.uuid_} useGestionShell />;
}

export default function CreateTournamentPage({
  competitionUUID,
  useGestionShell = false,
  match,
  history,
  location,
  ...props
}) {
  const [competition, setCompetition] = useState(null);
  const { user } = useContext(UserContext);
  const isGestionShell = useGestionShell || Boolean(match?.params?.customerId);

  useEffect(() => {
    if (!competitionUUID) return;
    performRequest("POST", competitionsShowRoute, { competition_uuid: competitionUUID }, true, user)
      .then((res) => setCompetition(res.data.data))
      .catch(console.error);
  }, [user, competitionUUID]);

  if (!competition) return <Loading />;

  const wizard = isGestionShell ? (
    <GestionLeagueTournamentWizard competition={competition} {...props} />
  ) : (
    <CreateTournamentWizard organization={competition.organization} competition={competition} {...props} />
  );

  const content = isGestionShell ? <GestionSubscriptionGate>{wizard}</GestionSubscriptionGate> : wizard;

  return (
    <AsyncPageWithDrawer
      match={match}
      history={history}
      location={location}
      drawerComponent={isGestionShell ? <GestionDrawer /> : <CompetitionDrawer competitionId={competitionUUID} />}
      enableDrawerCollapse
      content={content}
    />
  );
}
